import Repository from '@/repositories/marketing'

export default {
    getCampaignTags () {
        return Repository.get('camp_tags.json')
    },
    getContactTags () {
        return Repository.get('contact_tags.json')
    },
    getCouponTags () {
        return Repository.get('coupon_tags.json')
    },
    getDynamicAreaTags () {
        return Repository.get('dynamic_content_tags.json')
    },
    getTableTags () {
        return Repository.get('table_tags.json')
    },
    getOtherTags () {
        return Repository.get('other_tags.json')
    },
    getFunnelTags () {
        return Repository.get('funnel_tags.json')
    },
    getAbandonedCartTags () {
        return Repository.get('abandoned_cart_tags.json')
    },
    getProductFeedTemplatesTags (config) {
        return Repository.get('product_feed_templates_tags.json',config)
    },
    getDynamicContentTags () {
        return Repository.get('dynamic_content_tags.json')
    },
    getTemplateTags () {
        return Repository.get('template_tags.json')
    },
    getOptinTags(){
        return Repository.get(`optin_tags.json`)
    },
    getPreferenceTags(){
        return Repository.get(`preference_page_tags.json`)
    }
}
